exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".notify {\n  z-index: 999 !important;\n  display: none;\n  width: 400px;\n  position: fixed !important;\n  bottom: 100px;\n  right: 45px; }\n  .notify.show {\n    display: block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/Components/Notification/style.scss
// module id = 306
// module chunks = 0